<template>
    <div class="w-100">
        <BannersDesktop v-if="block.platform == 1" :block="block"></BannersDesktop>
        <BannersMobile v-if="block.platform != 1" :block="block"></BannersMobile>
    </div>
</template>
<script>
import BannersDesktop from '../../Desktop/Blocks/BannersNew';
import BannersMobile from '../../Mobile/Blocks/BannersNew';
import HomeBlock from '@/models/home-block';
export default {
    components:{
        BannersDesktop,
        BannersMobile
    },
    props:{
        block:{
            type: HomeBlock
        }
    }
}
</script>